import type { Nullable } from 'types';

export type RenderOptions = {
  boardToken: string;
  basePath?: string;
  ssoToken?: string;
  onLoadCallback?: () => void;
};

export type ChangeLogOptions = {
  appID: string;
  align: 'top' | 'bottom' | 'left' | 'right';
  position: 'top' | 'bottom' | 'left' | 'right';
  labelIDs?: string[];
};

export type IdentifyOptions = {
  appID: string;
  user: {
    id: string | number;
    email?: Nullable<string>;
    name: string;
  };
};

export class Canny {
  canny: Nullable<typeof window.Canny>;

  constructor(canny: Nullable<typeof window.Canny>) {
    this.canny = canny;
  }

  render(options: RenderOptions, element?: HTMLElement) {
    if (this.canny) {
      this.canny('render', options, element);
    }
  }

  initChangelog(options: ChangeLogOptions) {
    if (this.canny) {
      this.canny('initChangelog', options);
    }
  }

  closeChangelog() {
    if (this.canny) {
      this.canny('closeChangelog');
    }
  }

  identify(options: IdentifyOptions) {
    if (this.canny) {
      this.canny('identify', options);
    }
  }
}
